module.exports = __webpack_public_path__ + "img/a013_1.ae3ffa4c.jpg";